import { HonorariumPreLiquidationItemStatusId } from '../../dto/HonorariumPreLiquidationDTO';

interface PreLiquidationItemStatusTagProps {
    statusId: number;
    /** Descripción del estado que manda el backend ("Pendiente", "Liquidado"). */
    status: string;
}

/** Estado de un ítem de la pre-liquidación (DS §3.4): pendiente de liquidar o ya liquidado. */
export default function PreLiquidationItemStatusTag({ statusId, status }: PreLiquidationItemStatusTagProps) {
    const variant = statusId === HonorariumPreLiquidationItemStatusId.LIQUIDATED ? 'md-tag-ok' : 'md-tag-warn';
    return <span className={`md-tag ${variant}`}>{status}</span>;
}
